import Vue from 'vue'
import './plugins/bootstrap-vue'

import '@babel/polyfill'
import 'mutationobserver-shim'
import App from './App.vue'
import store from './store'
import router from './router'
import i18n from './i18n'
import alert from '@/util/global-alert'
import messages from '@/util/messages'
import { SETUP_FROM_DATA, LAST_TOKEN_UPDATE } from '@/store/consts'

import request from '@/plugins/request'
Vue.use(request)

Vue.prototype.post = request
Vue.prototype.$alert = alert
Vue.prototype.$messages = messages

Vue.config.productionTip = false

/*
  Ожидание получения данных о пользователе, если необходимо.
 */
function wait_user_data_then_init() {
  if (window._wait_prefuser) {
    setTimeout(wait_user_data_then_init, 500)
    return
  }
  if (window._pref_udata) {
    store.dispatch(SETUP_FROM_DATA, window._pref_udata.result.user);
    if (window._pref_token_updated) store.commit(LAST_TOKEN_UPDATE);
    messages.addAll(window._pref_udata.messages)
    console.log('Using prefetched user info, User: ', window._pref_udata.result)
  }

  new Vue({
    store,
    router,
    i18n,
    render: h => h(App),
  }).$mount('#app')
}
wait_user_data_then_init()

